/**
 * Steam profil adresi.
 *
 * SteamID64 zaten profilin adresidir; ekrana basılıp elle kopyalanacak bir
 * numara değil. Ekipteki her yer (başvurular, üye kartı) aynı adresi kursun
 * diye tek yerde durur.
 *
 * **ID'si elinde olan yer bunu kullanır.** `/api/members` `steam_id` alanını
 * yalnızca operatör ve üstüne gönderir (`OPERATOR_ROLES`), yani roster'da
 * adresi tarayıcıda kurabilen tek taraf ekiptir. Üyelerin gördüğü ad için
 * `memberSteamProfileUrl` var: adresi backend kurar, numara listede durmaz.
 */
export const steamProfileUrl = (steamId: string) =>
  `https://steamcommunity.com/profiles/${steamId}`

/**
 * Bir üyenin profiline giden dashboard yolu.
 *
 * Roster'da SteamID64 yalnızca operatör ve üstüne gönderiliyor, dolayısıyla
 * adresi tarayıcıda kuramayan herkes (üyeler, hatta kendi kartında kendisi)
 * tıklanamayan bir ad okuyordu. Adres backend'de kuruluyor: uç nokta dashboard
 * oturumu ister ve Steam'e 302 verir — kapı herkese açılır, numara listede
 * durmaz.
 */
export const memberSteamProfileUrl = (discordId: string) =>
  `/api/members/${discordId}/steam`
